/* eslint-disable indent */
import styled from 'styled-components';
import { TableRow, Text } from '@cashfree-intl/coherent';

export const StyledHeaderPgIncidents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 1rem;
`;

export const StyledCard = styled.div`
  width: 28.75rem;
  height: 11.25rem;
  background: white;
  border-radius: 0.5rem;
  border: 2px solid ${props => (props.active ? ' VAR(--PRIMARY)' : 'white')};
  cursor: pointer;
  margin-bottom: 2rem;
`;

export const StyledCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e6e9ee;
`;

export const StyledCardBody = styled.div`
  padding: 20px 24px 36px 24px;
`;

export const StyledHeadingText = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: black;
  margin-bottom: 12px;
`;

export const StyledWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > div {
    display: inherit;
    gap: 8px;
    align-items: center;
    padding-right: 8px;
  }
`;

export const StyledCardsGroup = styled.div`
  display: flex;
  gap: 40px;
`;

export const StyledDashboardFilter = styled.div`
  margin-top: 16px;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${props =>
    props.status === 'ACTIVE' ? '#FEF8F8' : 'white'} !important;
`;

export const StyledFlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledFlexText = styled(Text)`
  flex: none;
  padding-right: 4px;
  padding-left: ${props => props.pl}px;
`;

export const StyledSpan = styled.span`
  display: inline-flex;
`;

export const StyledBankImage = styled.img`
  width: 1.125rem;
`;
